export default "__VITE_ASSET__BIuVcIrQ__"